import { radarLayerId, radarSourceId } from '../data/radar.js';

/** Register RainViewer raster sources/layers; crossfade by opacity. */
export function ensureRadarLayers(map, frames) {
  frames.forEach((frame, i) => {
    const sid = radarSourceId(i);
    const lid = radarLayerId(i);
    if (map.getLayer(lid)) map.removeLayer(lid);
    if (map.getSource(sid)) map.removeSource(sid);
    map.addSource(sid, {
      type: 'raster',
      tiles: [`${frame.host}${frame.path}/256/{z}/{x}/{y}/6/1_0.png`],
      tileSize: 256,
      attribution: 'RainViewer',
      maxzoom: 7,
    });
    map.addLayer({
      id: lid,
      type: 'raster',
      source: sid,
      paint: {
        'raster-opacity': 0,
        'raster-fade-duration': 0,
      },
    });
  });
}

export function setRadarVisible(map, frames, activeIndex, blend = 0) {
  frames.forEach((_, i) => {
    const lid = radarLayerId(i);
    if (!map.getLayer(lid)) return;
    let opacity = 0;
    if (activeIndex >= 0) {
      if (i === activeIndex) opacity = 1 - blend * 0.4;
      if (i === Math.min(frames.length - 1, activeIndex + 1) && blend > 0) {
        opacity = Math.max(opacity, blend);
      }
    }
    map.setPaintProperty(lid, 'raster-opacity', opacity);
  });
}

export function hideAllRadar(map, frames) {
  setRadarVisible(map, frames, -1, 0);
}
